import React from "react";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import logo from "../../../images/IconLogo.png";

const DrawerHeader = ({ mobileOpen, handleDrawerToggle }) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent={mobileOpen ? "space-between" : "center"}
    sx={{ padding: mobileOpen ? "16px" : "8px 0" }}
  >
    {mobileOpen ? (
      <Box display="flex" alignItems="center">
        <img src={logo} alt="Logo" style={{ width: 36, height: 36, marginRight: 8 }} />
        <Typography variant="h6">Extend</Typography>
      </Box>
    ) : (
      <Tooltip title="Open Drawer">
        <IconButton style={{color:"white"}} onClick={handleDrawerToggle}>
          <MenuIcon />
        </IconButton>
      </Tooltip>
    )}
    {mobileOpen && (
      <Tooltip title="Close Drawer">
        <IconButton style={{color:"white"}} onClick={handleDrawerToggle}>
          <MenuIcon />
        </IconButton>
      </Tooltip>
    )}
  </Box>
);

export default DrawerHeader;
